import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const LottoOverview = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Automatisch zu Produktverwaltung weiterleiten
    navigate('/admin/lotto/produktverwaltung', { replace: true });
  }, [navigate]);

  return null;
};
